import React from "react";
import ReactSelect, { Props } from "react-select";
import { twMerge } from "tailwind-merge";

interface SelectProps extends Props {
  id?: string;
  error?: any;
  [x: string]: any;
}

const Select = React.forwardRef(
  (
    { placeholder, options, error, className, styles, ...rest }: SelectProps,
    ref: any
  ) => {
    return (
      <ReactSelect
        {...rest}
        placeholder={placeholder}
        options={options}
        menuPlacement="auto"
        classNames={{
          control: ({ isFocused }) =>
            twMerge(
              "select !rounded-lg !shadow-none",
              className,
              error
                ? "!border-red-500"
                : isFocused
                ? "!border-brand-500"
                : "!border-gray-300"
            ),
          multiValue: () => "!bg-magnolia-500",
          multiValueLabel: () => "bg-magnolia-500 !text-brand-500 font-medium",
          multiValueRemove: () => "bg-magnolia-500",
        }}
        styles={{
          input: (base) => ({
            ...base,
            "input:focus": {
              boxShadow: "none",
            },
          }),
          menu: (provided) => ({ ...provided, zIndex: 3 }),
          singleValue: (styles, { isDisabled }) => {
            return {
              ...styles,
              color: isDisabled ? 'hsl(0, 0%, 20%)' : styles?.color,
            };
          },
          ...styles,
        }}
      />
    );
  }
);

Select.displayName = "Select";

export default Select;
